import axios from "axios";
import _ from "lodash";
import {auth, cloudFunctionConfig, getCurrentUserIdToken, pinterestConfig} from "../../firebase/client-app";

export {
    fetchPinterestAccessToken,
    fetchPinterestUserAccount,
    syncPinterestAccount,
    syncPinterestBoards,
    createPinterestBoardAndSections,
    createPinterestSections,
    createPinterestPins,
}

const baseUrl = cloudFunctionConfig.localBaseUrl || cloudFunctionConfig.baseUrl;
const ACCOUNTS_BASE_URL = '/accounts';
const ACCOUNTS_OAUTH_ACCESS_TOKEN_URL = '/oauth/access-token';
const ACCOUNTS_URL = ACCOUNTS_BASE_URL + '/user_account';
const SYNC_ACCOUNT_URL = ACCOUNTS_BASE_URL + '/:pinterestAccountId/sync';
const BOARDS_URL = ACCOUNTS_BASE_URL + '/:pinterestAccountId/boards';
const SECTIONS_URL = BOARDS_URL + '/:boardId/sections';
const SYNC_BOARDS_BASE_URL = ACCOUNTS_BASE_URL + '/:pinterestAccountId/boards/sync';
const PINS_BASE_URL = ACCOUNTS_BASE_URL + '/:pinterestAccountId/pins';

const fetchPinterestAccessToken = async (code) => {
    let url = baseUrl + pinterestConfig.proxyApi + ACCOUNTS_OAUTH_ACCESS_TOKEN_URL;
    url += `?code=${code}`;
    return await makeGetCall(url);
}

const fetchPinterestUserAccount = async (code?) => {
    let url = baseUrl + pinterestConfig.proxyApi + ACCOUNTS_URL;

    if (code) {
        url += `?code=${code}`;
    }

    return await makeGetCall(url);
}

const syncPinterestAccount = async (pinterestAccountId) => {
    let url = baseUrl + pinterestConfig.proxyApi + SYNC_ACCOUNT_URL;
    url = url.replace(':pinterestAccountId', pinterestAccountId);
    return await makeGetCall(url);
}

const syncPinterestBoards = async (pinterestAccountId) => {
    let url = baseUrl + pinterestConfig.proxyApi + SYNC_BOARDS_BASE_URL;
    url = url.replace(':pinterestAccountId', pinterestAccountId);
    return await makeGetCall(url);
}

const createPinterestBoardAndSections = async (pinterestAccountId, pinterestBoard) => {
    let url = baseUrl + pinterestConfig.proxyApi + BOARDS_URL;
    url = url.replace(':pinterestAccountId', pinterestAccountId);
    return await makePostCall(url, pinterestBoard);
}

const createPinterestSections = async (pinterestAccountId, sectionsInput) => {
    let url = baseUrl + pinterestConfig.proxyApi + SECTIONS_URL;
    url = url.replace(':pinterestAccountId', pinterestAccountId);
    url = url.replace(':boardId', sectionsInput.boardId);
    return await makePostCall(url, sectionsInput);
}

const createPinterestPins = async (pinterestAccountId, pinsInput) => {
    let url = baseUrl + pinterestConfig.proxyApi + PINS_BASE_URL;
    url = url.replace(':pinterestAccountId', pinterestAccountId);
    return await makePostCall(url, pinsInput);
}

const makeGetCall = async (url) => {
    const idToken = await getCurrentUserIdToken();

    const config = {
        method: 'get',
        url: url,
        headers: {
            Authorization: `Bearer ${idToken}`,
        }
    }

    try {
        const {data} = await axios.request(config);
        return {
            data: data
        };
    } catch (error) {
        console.error('Error making GET call', error);
        return {error: error};
    }
}

const makePostCall = async (url, input) => {
    const idToken = await getCurrentUserIdToken();

    const config = {
        method: 'post',
        url: url,
        headers: {
            Authorization: `Bearer ${idToken}`,
        },
        data: input
    }

    try {
        const {data} = await axios.request(config);
        return {
            data: data
        };
    } catch (error) {
        console.error('Error making POST call', error);
        return {error: error};
    }
}

